// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  IS_PRODUCTION: false,
  MQTT_SERVICE_OPTIONS: {
    hostname: 'marsav.etic.cloud',
    port: 443,
    username: 'marsav_etic',
    password: 'ur21!.1olp#',
    protocol: 'wss',
    path: '/mqtt-ws',
  },
  BACKEND: "https://marsav-be.etic.cloud",
  MIDDLEWARE: "http://192.168.25.115:8010",
};




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
